import { CSSProperties, useCallback } from "react";
import { GroupedTableDataRowRenderProps } from "../types";
import { GroupedTableCell } from "../GroupedTableCell";

function GroupedTableDataRow<TRow>({
    columns,
    indentPx,
    onClick,
    row,
}: GroupedTableDataRowRenderProps<TRow>): JSX.Element {   
    const renderCell = useCallback((column: typeof columns[number], index: number) => {
        const style: CSSProperties = {};

        if (column.width) {
            style.width = isNaN(+column.width)
                ? column.width
                : `${column.width}px`;
            style.flexBasis = style.width;
        }

        if (index === 0) {
            style.paddingLeft = `${indentPx}px`;
        }

        return (
            <div className="GroupedTableFlatRow-Cell"
                 key={index}
                 style={style}>
                <GroupedTableCell<TRow> column={column}
                                        row={row.data} />
            </div>
        );
    }, [row, indentPx]);

    const onKeyDown = useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onClick?.();
        }
    }, [onClick]);

    return (
        <div className="GroupedTableDataRow"
             role={!onClick ? "row" : "link"}
             onClick={onClick}
             onKeyDown={onKeyDown}
             tabIndex={0}>
            {columns.map(renderCell)}
        </div>
    );
}

export default GroupedTableDataRow;
